export class AppConstans {
  public static readonly popVydalKodMze = '9999';
  public static readonly kategorieRm = {
    identifikovany: 1,
    selektovany: 2,
    kvalifikovany: 3,
    testovany: 4
  };
  public static readonly typZdrojeRm = {
    porost2A: '2A'
  };
}
